module.exports = __webpack_public_path__ + "media/images/tutorial_body_pc1-05-feaa18724a1c87adb80e28f81e737135.png";